import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const HistoryIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v6l3 3"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21a9 9 0 100-18 9 9 0 000 18z"
      />
    </>
  );

  return (
    <Icon svgPath={svgPath} className={className} title={title} fill="none" strokeWidth={1.5} />
  );
};

export default HistoryIcon;


